import { useApiQuery } from './useApiQuery'
import { apiRoutes } from './apiRoutes'
import { useIsPinPage } from './useIsPinPage'

export type FeatureFlags = Record<string, boolean>

export function useGetFeatureFlags(options: { enabled: boolean }) {
  const isPinPage = useIsPinPage()
  const enabled = options.enabled && !isPinPage
  return useApiQuery<FeatureFlags>(apiRoutes.getFeatureFlags(), {
    enabled,
    staleTime: 60 * 1000,
    cacheTime: 10 * 60 * 1000,
    retry: 1,
  })
}

export function useIsFeatureEnabled(flagKey: string): boolean {
  const { data } = useGetFeatureFlags({ enabled: true })
  return data?.[flagKey] === true
}
